import Parcel from '../../Parcel';
import ResponseResult from '../../ResponseResult';
import ResponseError from '../../ResponseError';
import {filtersToEndpoint, ordersToEndpoint} from '../../hydrate';

export default class WatchCandidateListParcel extends Parcel {

    constructor(filters = null, filtersConfig, orders = null, limit = null, offset = null) {
        super();

        this.setEndpoint('/api/watch-candidate/list');
        this.setRequestMethod('GET');

        if (filters !== null) {
            this.setQueryParam('filters', filtersToEndpoint(filters, filtersConfig));
        }

        if (orders !== null) {
            this.setQueryParam('orders', ordersToEndpoint(orders));
        }

        if (limit !== null) {
            this.setQueryParam('limit', limit);
        }

        if (offset !== null) {
            this.setQueryParam('offset', offset);
        }
    }

    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }

    parseResponseResult(rawResult) {
        if (rawResult.error) {
            return new ResponseResult(null, new ResponseError(rawResult.error.message));
        }

        return new ResponseResult(rawResult.data, null);
    }
}
